import { render, staticRenderFns } from "./podcast.vue?vue&type=template&id=298e43e6&scoped=true"
import script from "./podcast.vue?vue&type=script&lang=js"
export * from "./podcast.vue?vue&type=script&lang=js"
import style0 from "./podcast.vue?vue&type=style&index=0&id=298e43e6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298e43e6",
  null
  
)

export default component.exports